import { useRouterState } from "@tanstack/react-router";
import { Suspense, lazy } from "react";

import { useSiteContent } from "@/lib/content";

/**
 * گفتگوی زنده با import پویا: دکمه و پنجره‌اش تا پیش از کلیک کاربر دیده نمی‌شوند، ولی کدشان
 * (حدود ۹۵۰ خط به‌علاوه‌ی بارگذاری فایل و اتصال زنده) در چانکِ ورودی بود و موقع باز شدن هر
 * صفحه پارس و اجرا می‌شد. ریشه‌ی سایت این را پس از بیکار شدن مرورگر سوار می‌کند (__root.tsx).
 */
const LiveChatWidget = lazy(() =>
  import("@/components/live-chat-widget").then((module) => ({ default: module.LiveChatWidget })),
);

export function LiveChat() {
  const content = useSiteContent().liveChat;
  const pathname = useRouterState({ select: (state) => state.location.pathname });
  // the pay pages (a customer's /pay, a Lead's deposit link /d/…) stay free of the widget
  const paying = pathname.startsWith("/pay") || pathname.startsWith("/d/");
  // خاموش یا صفحه‌ی پرداخت: چانک گفتگو اصلاً گرفته نمی‌شود
  if (content.enabled === "off" || paying) return null;
  return (
    <Suspense fallback={null}>
      <LiveChatWidget pathname={pathname} />
    </Suspense>
  );
}
